import React,{useState} from 'react';
import Modal from 'react-responsive-modal';
import {injectIntl} from 'react-intl';
import ChannelService from 'services/ChannelService';
import { SelectionState } from 'draft-js';


const DeleteModal =  ( props ) => {

  const [state,setState] = useState({reasons:[]})

  const { label, onConfirm, onToggle, opened, intl, isDismiss,test } = props;
  const data = "test reason";
  const reason = isDismiss ? true : false
  if(reason){
    ChannelService.getDismissReason().then((response)=>{
      setState({reasons:response.data});
    })
  }
  
  const sendReason = () => {
     onConfirm(data);
  }
  return (
    <Modal closeOnEsc={false}
           little
           modalClassName="col-md-4"
           onClose={onToggle}
           open={opened}
           showCloseIcon={false}
    >
      <div className="text-center">
        <i className="fa fa-warning text-large color-warning"/>
        <h5>{label || 'Are you sure?'}</h5>
      </div>
      {reason && 
      <label>Reason</label>
      }
      <hr/>
      <div className="text-right">
        <button className="btn btn-danger mr-3" onClick={sendReason}>{ intl.formatMessage( { id: 'yes' } ) }</button>
        <button className="btn btn-outline-secondary" onClick={onToggle}>{ intl.formatMessage( { id: 'cancel' } ) }</button>
      </div>
    </Modal>
  );
}

module.exports = injectIntl( DeleteModal );



// WEBPACK FOOTER //
// ./components/HTMLElements/DeleteModal/index.js